import React from 'react';
import { Typography } from '@mui/material';

const DSTypography = (props: React.ComponentProps<typeof Typography>) => {
  return <Typography {...props} />;
};

export default DSTypography;
